export function renderErrorPage(errorMsg: string): void {
    // Hide spinner and svg related to loading state, left logo
    const spinnedEl: HTMLElement = document.querySelector('.loader-spinner');
    spinnedEl.style.display = 'none';

    const svgEls = document.querySelectorAll('.init-loader > svg');
    svgEls.forEach((el: HTMLElement) => {
        el.style.display = 'none';
    });

    // Render error element
    const errorEl = document.createElement('div');
    errorEl.style.textAlign = 'center';

    const headingEl = document.createElement('h3');
    headingEl.innerText = 'An unexpected error has occurred';
    headingEl.classList.add('text-h1', 'text-primary-darker');

    const textEl = document.createElement('div');
    textEl.innerText = errorMsg;
    textEl.classList.add('text-body1', 'text-primary-darker');

    errorEl.appendChild(headingEl);
    errorEl.appendChild(textEl);

    const parent = document.querySelector('.init-loader');

    parent?.appendChild(errorEl);
}
